module.exports = __webpack_public_path__ + "img/baizhi.cc013458.jpg";